export const removeMarkTagsFromString = (string: string): string =>
  string.replace(/(<\/?mark>)/gi, '');
